import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

i18next.use(initReactI18next).init({
  interpolation: {
    // React already does escaping
    escapeValue: false,
  },
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  // Using simple hardcoded resources for simple example
  resources: {
    'en-GB': {
      translation: {
        Disclaimer: `% figures shown below refer to the performance of a representative index or benchmark compared to its Net
        Asset Value (NAV) on the previous trading day, and are for illustration and informational purposes only.
        Historical performance is not an indication of future performance and any investments may go down in
        value. You cannot invest directly in an index.`,

        Negative: 'Negative',
        Positive: 'Positive',

        ProdNotAvailable: 'Products not available in your region.',

        Equities: 'Equities',
        Commodities: 'Commodities',
        Currencies: 'Currencies',

        Thematic: 'Thematic',
        'Broad Market': 'Broad Market',
        'Broad Commodities': 'Broad Commodities',
        'Precious Metals': 'Precious Metals',
        'Industrial Metals': 'Industrial Metals',
        Energy: 'Energy',
        Agriculture: 'Agriculture',
        'EUR Pairs': 'EUR Pairs',
        'GBP Pairs': 'GBP Pairs',
        'USD Pairs': 'USD Pairs',
        'JPY Pairs': 'JPY Pairs',

        USDEUR: 'USD/EUR',
        EURUSD: 'EUR/USD',

        EURGBP: 'EUR/GBP',
        GBPEUR: 'GBP/EUR',

        USDGBP: 'USD/GBP',
        GBPUSD: 'GBP/USD',

        USDJPY: 'USD/JPY',
        JPYUSD: 'JPY/USD',
        USDCNY: 'USD/CNY',
        GBPJPY: 'GBP/JPY',
        GBPCHF: 'GBP/CHF',
        EURAUD: 'EUR/AUD',
        EURCHF: 'EUR/CHF',
        EURJPY: 'EUR/JPY',
        EURNOK: 'EUR/NOK',
        EURSEK: 'EUR/SEK',

        LongProdDesc: 'Long products related to',
        ShortProdDesc: 'Short products related to',
        ProductRelatedTo: 'Products related to',
        PercentageChange: '% change previous trading day',
        LastUpdated: 'Last updated',
        Months: JSON.stringify([
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ]),
        ErrorHeading: 'Oops! Something went wrong.',
        PleaseReloadText: 'Please reload the page to restart the app, or',
        ContactUs: 'contact us',
        ProblemPersists: 'if the problem persists.',
        UpcomingEvents: 'Upcoming Events',
        moreDetails: 'More details',
        viewProducts: 'View products',
        clickToView: 'Click to view',
        backTo: 'Back to',
        seeLess: 'See less',
        seeMore: 'See More',
        NoResultFoundMsg: 'Sorry, we couldn\'t find any result matching',
        NoPostToDisplay: 'Sorry, There are no posts published lately.',
        ViewEvent: 'View Event',
        WisdomTree: 'WisdomTree',
        HeatMapInfo: 'The WisdomTree Tactical heatmap illustrates the daily movement of underlying benchmarks for all asset classes.',
        HeatMapAppHeading: 'Tactical Heatmap',
      },
    },
    'it-IT': {
      translation: {
        Disclaimer:
          'I dati percentuali (%) illustrati di seguito si riferiscono alla performance di un indice o di un benchmark rappresentativo rispetto al suo NAV (Net Asset Value o valore patrimoniale netto) il giorno di negoziazione precedente e sono indicati a scopo esclusivamente illustrativo. La performance storica non è indicativa dei risultati futuri e qualunque investimento può scendere di valore. Non è possibile investire direttamente in un indice.',

        Negative: 'Negativo',
        Positive: 'Positivo',
        Filter: 'Filtrare',
        Sort: 'Ordinare',

        ProdNotAvailable: 'Nessun prodotto correlato disponibile nella tua regione.',

        Name: 'Prodotto',
        'Base Currency': 'Valuta di base',
        'Leverage Factor': 'Fattore leva',

        Equities: 'Azioni',
        Commodities: 'Materie Prime',
        Currencies: 'Valute',
        'Fixed Income': 'Reddito fisso',

        Thematic: 'Tematica',
        'Broad Market': 'Mercato ampio',
        'Broad Commodities': 'Generale',
        'Precious Metals': 'Metalli preziosi',
        'Industrial Metals': 'Metalli industriali',
        Energy: 'Energia',
        Agriculture: 'Agricoltura',
        'EUR Pairs': 'Coppie EUR',
        'GBP Pairs': 'Coppie GBP',
        'USD Pairs': 'Coppie USD',
        'JPY Pairs': 'Coppie JPY',
        'All Commodities': 'Tutte le commodity',
        Gold: 'Oro',
        Platinum: 'Platino',
        Palladium: 'Palladio',
        Silver: 'Argento',
        Copper: 'Rame',
        Nickel: 'Nickel',
        'Energy Basket': 'Energia',
        'Brent Crude': 'Petrolio greggio (Brent)',
        'WTI Crude': 'Petrolio greggio (WTI)',
        Gasoline: 'Gasoline',
        'Natural Gas': 'Gas Naturale',
        Coffee: 'Caffé',
        Wheat: 'Frumento',
        Sugar: 'Zucchero',
        Grains: 'Cereali',
        Soybeans: 'Semi di Soia',
        Corn: 'Mais',
        'Live Cattle': 'Bovini vivi',
        Livestock: 'Bestiame',
        'Lean Hogs': 'Suino magro',
        Cocoa: 'Cacao',
        LongProdDesc: 'Prodotti a leva finanziaria relativi a',
        ShortProdDesc: 'Prodotti short relativi a',
        ProductRelatedTo: 'Prodotti relativi a',
        PercentageChange: 'Variazione % giorno di negoziazione precedente',
        LastUpdated: 'Ultimo aggiornamento',
        Months: JSON.stringify([
          'Gennaio',
          'Febbraio',
          'Marzo',
          'Aprile',
          'Maggio',
          'Giugno',
          'Luglio',
          'Agosto',
          'Settembre',
          'Ottobre',
          'Novembre',
          'Dicembre',
        ]),
        ErrorHeading: 'Ops! Qualcosa è andato storto.',
        PleaseReloadText: "Ricarica la pagina per riavviare l'app, oppure",
        ContactUs: 'Contattaci',
        ProblemPersists: 'se il problema persiste.',
        UpcomingEvents: 'Prossimi eventi',
        HeatMapInfo: 'La Heatmap tattica di WisdomTree illustra il movimento giornaliero dei benchmark sottostanti per tutte le asset class.',
        HeatMapAppHeading: 'Heatmap Tattica',
      },
    },
    'de-DE': {
      translation: {
        Disclaimer:
          'Die unten angezeigten Prozentangaben (%) beziehen sich auf die Performance eines repräsentativen Index bzw. Referenzindex im Vergleich zu dessen Nettoinventarwert (NAV) am vorherigen Handelstag. Sie dienen ausschließlich Illustrationszwecken. Die historische Performance ist kein Anhaltspunkt für die künftige Performance und jedes Investment kann im Wert sinken. Ein direktes Investment in einen Index ist nicht möglich.',

        Name: 'Produkt',
        'Base Currency': 'Basiswährung',
        'Leverage Factor': 'Hebelfaktor',

        ProdNotAvailable: 'Keine verbundenen Produkte in Ihrer Region verfügbar.',

        Negative: 'Negativ',
        Positive: 'Positiv',
        Filter: 'Filter',
        Sort: 'Sortieren',

        Equities: 'Aktien',
        Commodities: 'Rohstoffe',
        Currencies: 'Währungen',
        'Fixed Income': 'Anleihen',

        Thematic: 'Thematisch',
        'Broad Market': 'Breiter Markt',
        'Broad Commodities': 'Rohstoffkörbe',
        'Precious Metals': 'Edelmetalle',
        'Industrial Metals': 'Industriemetalle',
        Energy: 'Energie',
        Agriculture: 'Landwirtschaft',
        'EUR Pairs': 'EUR-Basis',
        'GBP Pairs': 'GBP-Basis',
        'USD Pairs': 'USD-Basis',
        'JPY Pairs': 'JPY-Basis',
        'All Commodities': 'Alle Rohstoffe',
        Gold: 'Gold',
        Platinum: 'Platin',
        Palladium: 'Palladium',
        Silver: 'Silber',
        Copper: 'Kupfer',
        Nickel: 'Nickel',
        'Energy Basket': 'Energie',
        'Brent Crude': 'Rohöl (Brent)',
        'WTI Crude': 'Rohöl (WTI)',
        Gasoline: 'Benzin',
        'Natural Gas': 'Erdgas',
        Coffee: 'Kaffee',
        Wheat: 'Weizen',
        Sugar: 'Zucker',
        Grains: 'Getreide',
        Soybeans: 'Sojabohnen',
        Corn: 'Mais',
        'Live Cattle': 'Lebendrind',
        Livestock: 'Lebendvieh',
        'Lean Hogs': 'Schwein',
        Cocoa: 'Kakao',
        LongProdDesc: 'Long-Produkte im Zusammenhang mit',
        ShortProdDesc: 'Short-Produkte im Zusammenhang mit',
        ProductRelatedTo: 'Produkte im Zusammenhang mit',
        PercentageChange: '% Veränderung voriger Handelstag',
        LastUpdated: 'Zuletzt aktualisiert',
        Months: JSON.stringify([
          'Januar',
          'Februar',
          'Marsch',
          'April',
          'Kann',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember',
        ]),
        ErrorHeading: 'Hoppla! Etwas ist schief gelaufen.',
        PleaseReloadText: 'Bitte laden Sie die Seite neu, um die App neu zu starten, oder',
        ContactUs: 'kontaktiere uns',
        ProblemPersists: 'wenn das Problem weiterhin besteht.',
        UpcomingEvents: 'Kommende Veranstaltungen',
        HeatMapInfo: 'Die Taktische Heatmap von WisdomTree veranschaulicht die tägliche Entwicklung der zugrunde liegenden Benchmarks für alle Anlageklassen.',
        HeatMapAppHeading: 'Taktische Heatmap',
      },
    },
  },
});

export default i18next;
